import { Component, ChangeDetectionStrategy, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TopbarComponent } from './layout/topbar/topbar';
import { MobileHeaderComponent } from './layout/mobile-shell/mobile-header';
import { MobileNavComponent } from './layout/mobile-shell/mobile-nav';
import { FooterComponent } from './layout/footer/footer';
// TEMP: Factur.ro promo banner disabled until traction.
// import { FacturPromoBannerComponent } from './shared/components/factur-promo-banner/factur-promo-banner';
import { CookieConsentBannerComponent } from './shared/components/cookie-consent-banner/cookie-consent-banner';
import { IosInstallBannerComponent } from './shared/components/ios-install-banner/ios-install-banner';
import { ThemeService } from './core/services/theme.service';
import { BreadcrumbService } from './core/services/breadcrumb.service';
import { AuthService } from './core/services/auth.service';
import { CookieConsentService } from './core/services/cookie-consent.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TopbarComponent, MobileHeaderComponent, MobileNavComponent, FooterComponent, CookieConsentBannerComponent, IosInstallBannerComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  private readonly themeService = inject(ThemeService);
  private readonly breadcrumbService = inject(BreadcrumbService);
  private readonly authService = inject(AuthService);
  private readonly cookieConsentService = inject(CookieConsentService);
  private readonly platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.themeService.initialize();
      this.cookieConsentService.initialize();
    }
    this.breadcrumbService.initialize();
    this.authService.initialize();
  }
}
